import React, { FC } from 'react';

export const PublicHomePage: FC = () => (
	<div>
		<h2>Public Homepage</h2>
		<div>
			Julkinen kotisivu. Tälle sivulle pääse ei vaadi kirjautumista/autentikaatiota, eikä sivulla
			näytetä käyttäjäkohtaisia tietoja. <br />
			<br /> Tuotannossa asiakas voidaan ohjata suoraan kirjautumiseen käymättä tällä sivulla.
		</div>
	</div>
);
